import { EndpointGuard } from '../../helpers/auth';
import { hubsReports } from './_api/hubs'; // hubReport,

export const routeGuard: EndpointGuard = [hubsReports]; // add here hubReport
